import React from "react";
import "./style.css";

function Header() {
  return (
    <div className="header">
      <span>My Todo List</span>
      <span>React</span>
    </div>
  );
}

export default Header;
